import {  types  } from '../../actions'

function getSeasonTemplate(seasons){
       
	const seasonTemplate = {}
	
		seasons.map(function(season) {
	
			const { id,isSeasonSet, notificationSettings  } = season
			const template = {
				seasonId: id,
				notificationSettings,
				isSeasonSet
			}
			seasonTemplate[id] = template
		})
		return seasonTemplate
}
export default function seasontemplate (state,action) {   
        const {  payload } = action      
        switch(action.type) {
          
					case (types.Season.FETCH_ACTIVE_SEASONS): {           
						const { data } = payload
						if (data) {                
							const defaultId = payload.data[0].id
							const template = getSeasonTemplate(data)
							
							return Object.assign({},state,{
								values: {
								template,
								settingsseason:defaultId,
								initialstate:template
							},
								fields: {
									template,
									settingsseason:defaultId,
									initialstate:template
								}
							}
							)
							}
							else {
									return state
							}
					}
					case ( types.Season.TRIGGER_SEASON): {           
						const { data } = payload
						if (data) {                
							const defaultId = payload.data[data.length - 1].id
							const template = getSeasonTemplate(data)
							
							return Object.assign({},state,{
								values: {
									template,
									settingsseason:defaultId,
									initialstate:template
								},
								fields: {
									template,
									settingsseason:defaultId,
									initialstate:template
								}
							}
						)
						}
						else {
								return state
						}
					}
					case types.Season.SAVE_EMAIL_SETTINGS: {
						const datasaved  = true 
						const savingemailsettings = false
						return  { ...state, 
							values: {
							...state.values,
							savingemailsettings,
							datasaved,
							initialstate:state.values.template         
							},
							fields: {
								...state.fields,
								savingemailsettings,
								datasaved,
								initialstate:state.values.template  
							}
						}
					}
					case types.Season.SAVING_EMAIL_SETTINGS: {
						const savingemailsettings = true;
						return  { ...state, 
							values: {
							...state.values,
							savingemailsettings  
							},
							fields: {
								...state.fields,
								savingemailsettings
							}
						}
					}
					case types.Season.RESET_TEMPLATE_SETTINGS:{
						
						const { initialstate } = state.values
						
						return  { ...state, 
							values: {
								...state.values,
								participants:initialstate,
								templatereset:true
							},
							fields:{
								...state.fields,
								participants:initialstate,
								templatereset:true
							}
						}
					}
					default: return state
        }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/forms/seasontemplate.js